export default __webpack_public_path__ + "static/media/verification-blue.3bdf8351.svg";